<div class="contenitore" *ngIf="datiSurvey">
  <div class="landing-page" *ngIf="landingPage" [innerHtml]="landingPage"></div>
  <!----------------------------- T E S T A T A ------------------------>

  <div class="titolo">
    <app-titolo-subtitolo titolo="{{ datiSurvey.titolo }}"></app-titolo-subtitolo>

    <div [riempi]="true" appFormElement>
      <app-separatore-label [styleSeparatore]="'medium'"></app-separatore-label>
    </div>

    <div *ngIf="idSurveyCompilato" class="data-compilazione">
      Data Compilazione:
      <div class="data">{{ dataCompilazione }}</div>
    </div>
  </div>

  <div class="cnt-lista-elementi">
    <!----------------------------- A M B I T I ------------------------>
    @for (ambito of datiSurvey.ambiti; track $index) {
      <div class="titolo-ambito">Ambito - {{ ambito.titolo }}</div>

      <!----------------------------- T E M A T I C A ------------------------>
      @for (tematica of ambito.tematiche; track $index) {
        <div [id]="tematica.id" class="titolo-temtaica">Tematica - {{ tematica.domanda }}</div>

        @if (tematica?.temiIro?.length) {
          <!-- LIVELLO IRO TEMA -->

          <!----------------------------- T E M A ------------------------>
          @for (temaIro of tematica.temiIro; track $index) {
            <div class="titolo-tema">
              <!-- Etichetta -->
              @if (etichetteESRS && etichetteESRS[temaIro.id]) {
                <span class="etichetta-esrs">{{ etichetteESRS[temaIro.id] }} - </span>
              }
              {{ temaIro.nomeBreve + (temaIro.descrizione ? ' - ' + temaIro.descrizione : '') }}
            </div>

            <!-- ---------- IMPATTI --------->
            @if (temaIro.impattiIro.length) {
              <div class="tag-elemento">IMPATTI</div>
              @for (impattoIro of temaIro.impattiIro; track $index) {
                <div class="cnt-elemento">
                  <div class="cnt-titolo-icona">
                    <div class="titolo-impatto">{{ impattoIro.titolo }}</div>
                    <!-- ICONA INFO IRO -->
                    <ng-container
                      [ngTemplateOutlet]="iconaInfoIro"
                      [ngTemplateOutletContext]="{ iro: impattoIro, tipoIro: 'impatto' }"
                    ></ng-container>
                  </div>

                  <div class="descrizione-elemento">{{ impattoIro.descrizione }}</div>
                </div>

                <div class="cnt-valutazione">
                  <app-my-rating-star
                    titolo="Entità"
                    [infoElemento]="setInfoElemento('ENTITA')"
                    [mostraPunteggio]="false"
                    [idSurveyCompilato]="idSurveyCompilato"
                    idRating="{{ impattoIro.id }}"
                    [numeroStelle]="5"
                    [valoreAtribuito]="impattoIro.entita ? impattoIro.entita : 0"
                    (valueChangePunteggio)="impattoIro.entita = $event"
                  ></app-my-rating-star>

                  <app-my-rating-star
                    titolo="Portata"
                    [infoElemento]="setInfoElemento('PORTATA')"
                    [mostraPunteggio]="false"
                    [idSurveyCompilato]="idSurveyCompilato"
                    idRating="{{ impattoIro.id }}"
                    [numeroStelle]="5"
                    [valoreAtribuito]="impattoIro.portata ? impattoIro.portata : 0"
                    (valueChangePunteggio)="impattoIro.portata = $event"
                  ></app-my-rating-star>

                  @if (impattoIro.impattoPositivoNegativo?.includes('Negativo')) {
                    <app-my-rating-star
                      titolo="Irrimediabilità"
                      [infoElemento]="setInfoElemento('IRRIMEDIABILITA')"
                      [mostraPunteggio]="false"
                      [idSurveyCompilato]="idSurveyCompilato"
                      idRating="{{ impattoIro.id }}"
                      [numeroStelle]="5"
                      [valoreAtribuito]="
                        impattoIro.irrimediabilita ? impattoIro.irrimediabilita : 0
                      "
                      (valueChangePunteggio)="impattoIro.irrimediabilita = $event"
                    ></app-my-rating-star>
                  }

                  @if (impattoIro.impattoPotenzialeEffettivo?.includes('Potenziale')) {
                    <app-my-rating-star
                      titolo="Probabilità"
                      [infoElemento]="setInfoElemento('PROBABILITA')"
                      [mostraPunteggio]="false"
                      [idSurveyCompilato]="idSurveyCompilato"
                      idRating="{{ impattoIro.id }}"
                      [numeroStelle]="5"
                      [valoreAtribuito]="
                        impattoIro.possibilitaAccadimento ? impattoIro.possibilitaAccadimento : 0
                      "
                      (valueChangePunteggio)="impattoIro.possibilitaAccadimento = $event"
                    ></app-my-rating-star>
                  }
                </div>
              }
            }
            <!-- ---------- RISCHI --------->
            @if (temaIro.rischi.length) {
              <div class="tag-elemento">RISCHI</div>
              @for (rischi of temaIro.rischi; track $index) {
                <div class="cnt-elemento">
                  <div class="cnt-titolo-icona">
                    <div class="descrizione-elemento">{{ rischi.descrizione }}</div>
                    <!-- ICONA INFO IRO -->
                    <ng-container
                      [ngTemplateOutlet]="iconaInfoIro"
                      [ngTemplateOutletContext]="{ iro: rischi, tipoIro: 'rischio' }"
                    ></ng-container>
                  </div>
                </div>

                <div class="cnt-valutazione">
                  <app-my-rating-star
                    titolo="Severità"
                    [infoElemento]="setInfoElemento('SEVERITA')"
                    [mostraPunteggio]="false"
                    [idSurveyCompilato]="idSurveyCompilato"
                    idRating="{{ rischi.id }}"
                    [numeroStelle]="5"
                    [valoreAtribuito]="rischi.severita ? rischi.severita : 0"
                    (valueChangePunteggio)="rischi.severita = $event"
                  ></app-my-rating-star>

                  <app-my-rating-star
                    titolo="Probabilità"
                    [infoElemento]="setInfoElemento('PROBABILITA_RISCHI_OPPORTUNITA')"
                    [mostraPunteggio]="false"
                    [idSurveyCompilato]="idSurveyCompilato"
                    idRating="{{ rischi.id }}"
                    [numeroStelle]="5"
                    [valoreAtribuito]="rischi.probabilita ? rischi.probabilita : 0"
                    (valueChangePunteggio)="rischi.probabilita = $event"
                  ></app-my-rating-star>
                </div>
              }
            }
            <!-- ---------- OPPORTUNITA --------->
            @if (temaIro.opportunita.length) {
              <div class="tag-elemento">OPPORTUNITÀ</div>
              @for (opportunita of temaIro.opportunita; track $index) {
                <div class="cnt-elemento">
                  <div class="cnt-titolo-icona">
                    <div class="descrizione-elemento">{{ opportunita.descrizione }}</div>
                    <!-- ICONA INFO IRO -->
                    <ng-container
                      [ngTemplateOutlet]="iconaInfoIro"
                      [ngTemplateOutletContext]="{ iro: opportunita, tipoIro: 'opportunita' }"
                    ></ng-container>
                  </div>
                </div>

                <div class="cnt-valutazione">
                  <app-my-rating-star
                    titolo="Severità"
                    [infoElemento]="setInfoElemento('SEVERITA')"
                    [mostraPunteggio]="false"
                    [idSurveyCompilato]="idSurveyCompilato"
                    idRating="{{ opportunita.id }}"
                    [numeroStelle]="5"
                    [valoreAtribuito]="opportunita.severita ? opportunita.severita : 0"
                    (valueChangePunteggio)="opportunita.severita = $event"
                  ></app-my-rating-star>

                  <app-my-rating-star
                    titolo="Probabilità"
                    [infoElemento]="setInfoElemento('PROBABILITA_RISCHI_OPPORTUNITA')"
                    [mostraPunteggio]="false"
                    [idSurveyCompilato]="idSurveyCompilato"
                    idRating="{{ opportunita.id }}"
                    [numeroStelle]="5"
                    [valoreAtribuito]="opportunita.probabilita ? opportunita.probabilita : 0"
                    (valueChangePunteggio)="opportunita.probabilita = $event"
                  ></app-my-rating-star>
                </div>
              }
            }
          }
        } @else {
          <!-- LIVELLO IRO TEMATICA -->

          <!-- ---------- IMPATTI --------->
          @if (tematica.impattiIro.length) {
            <div class="tag-elemento">IMPATTI</div>
            @for (impattoIro of tematica.impattiIro; track $index) {
              <div class="cnt-elemento">
                <div class="cnt-titolo-icona">
                  <div class="titolo-impatto">{{ impattoIro.titolo }}</div>
                  <!-- ICONA INFO IRO -->
                  <ng-container
                    [ngTemplateOutlet]="iconaInfoIro"
                    [ngTemplateOutletContext]="{ iro: impattoIro, tipoIro: 'impatto' }"
                  ></ng-container>
                </div>

                <div class="descrizione-elemento">{{ impattoIro.descrizione }}</div>
              </div>

              <div class="cnt-valutazione">
                <app-my-rating-star
                  titolo="Entità"
                  [infoElemento]="setInfoElemento('ENTITA')"
                  [mostraPunteggio]="false"
                  [idSurveyCompilato]="idSurveyCompilato"
                  idRating="{{ impattoIro.id }}"
                  [numeroStelle]="5"
                  [valoreAtribuito]="impattoIro.entita ? impattoIro.entita : 0"
                  (valueChangePunteggio)="impattoIro.entita = $event"
                ></app-my-rating-star>

                <app-my-rating-star
                  titolo="Portata"
                  [infoElemento]="setInfoElemento('PORTATA')"
                  [mostraPunteggio]="false"
                  [idSurveyCompilato]="idSurveyCompilato"
                  idRating="{{ impattoIro.id }}"
                  [numeroStelle]="5"
                  [valoreAtribuito]="impattoIro.portata ? impattoIro.portata : 0"
                  (valueChangePunteggio)="impattoIro.portata = $event"
                ></app-my-rating-star>

                @if (impattoIro.impattoPositivoNegativo?.includes('Negativo')) {
                  <app-my-rating-star
                    titolo="Irrimediabilità"
                    [infoElemento]="setInfoElemento('IRRIMEDIABILITA')"
                    [mostraPunteggio]="false"
                    [idSurveyCompilato]="idSurveyCompilato"
                    idRating="{{ impattoIro.id }}"
                    [numeroStelle]="5"
                    [valoreAtribuito]="impattoIro.irrimediabilita ? impattoIro.irrimediabilita : 0"
                    (valueChangePunteggio)="impattoIro.irrimediabilita = $event"
                  ></app-my-rating-star>
                }

                @if (impattoIro.impattoPotenzialeEffettivo?.includes('Potenziale')) {
                  <app-my-rating-star
                    titolo="Probabilità"
                    [infoElemento]="setInfoElemento('PROBABILITA')"
                    [mostraPunteggio]="false"
                    [idSurveyCompilato]="idSurveyCompilato"
                    idRating="{{ impattoIro.id }}"
                    [numeroStelle]="5"
                    [valoreAtribuito]="
                      impattoIro.possibilitaAccadimento ? impattoIro.possibilitaAccadimento : 0
                    "
                    (valueChangePunteggio)="impattoIro.possibilitaAccadimento = $event"
                  ></app-my-rating-star>
                }
              </div>
            }
          }
          <!-- ---------- RISCHI --------->
          @if (tematica.rischi.length) {
            <div class="tag-elemento">RISCHI</div>
            @for (rischi of tematica.rischi; track $index) {
              <div class="cnt-elemento">
                <div class="cnt-titolo-icona">
                  <div class="descrizione-elemento">{{ rischi.descrizione }}</div>
                  <!-- ICONA INFO IRO -->
                  <ng-container
                    [ngTemplateOutlet]="iconaInfoIro"
                    [ngTemplateOutletContext]="{ iro: rischi, tipoIro: 'rischio' }"
                  ></ng-container>
                </div>
              </div>
              <div class="cnt-valutazione">
                <app-my-rating-star
                  titolo="Severità"
                  [infoElemento]="setInfoElemento('SEVERITA')"
                  [mostraPunteggio]="false"
                  [idSurveyCompilato]="idSurveyCompilato"
                  idRating="{{ rischi.id }}"
                  [numeroStelle]="5"
                  [valoreAtribuito]="rischi.severita ? rischi.severita : 0"
                  (valueChangePunteggio)="rischi.severita = $event"
                ></app-my-rating-star>

                <app-my-rating-star
                  titolo="Probabilità"
                  [infoElemento]="setInfoElemento('PROBABILITA_RISCHI_OPPORTUNITA')"
                  [mostraPunteggio]="false"
                  [idSurveyCompilato]="idSurveyCompilato"
                  idRating="{{ rischi.id }}"
                  [numeroStelle]="5"
                  [valoreAtribuito]="rischi.probabilita ? rischi.probabilita : 0"
                  (valueChangePunteggio)="rischi.probabilita = $event"
                ></app-my-rating-star>
              </div>
            }
          }
          <!-- ---------- OPPORTUNITA --------->
          @if (tematica.opportunita.length) {
            <div class="tag-elemento">OPPORTUNITÀ</div>
            @for (opportunita of tematica.opportunita; track $index) {
              <div class="cnt-elemento">
                <div class="cnt-titolo-icona">
                  <div class="descrizione-elemento">{{ opportunita.descrizione }}</div>
                  <!-- ICONA INFO IRO -->
                  <ng-container
                    [ngTemplateOutlet]="iconaInfoIro"
                    [ngTemplateOutletContext]="{ iro: opportunita, tipoIro: 'opportunita' }"
                  ></ng-container>
                </div>
              </div>
              <div class="cnt-valutazione">
                <app-my-rating-star
                  titolo="Severità"
                  [infoElemento]="setInfoElemento('SEVERITA')"
                  [mostraPunteggio]="false"
                  [idSurveyCompilato]="idSurveyCompilato"
                  idRating="{{ opportunita.id }}"
                  [numeroStelle]="5"
                  [valoreAtribuito]="opportunita.severita ? opportunita.severita : 0"
                  (valueChangePunteggio)="opportunita.severita = $event"
                ></app-my-rating-star>

                <app-my-rating-star
                  titolo="Probabilità"
                  [infoElemento]="setInfoElemento('PROBABILITA_RISCHI_OPPORTUNITA')"
                  [mostraPunteggio]="false"
                  [idSurveyCompilato]="idSurveyCompilato"
                  idRating="{{ opportunita.id }}"
                  [numeroStelle]="5"
                  [valoreAtribuito]="opportunita.probabilita ? opportunita.probabilita : 0"
                  (valueChangePunteggio)="opportunita.probabilita = $event"
                ></app-my-rating-star>
              </div>
            }
          }
        }
      }
    }
  </div>
</div>

<!-- TEMPLATE ICONA INFO IRO -->
<ng-template #iconaInfoIro let-iro="iro" let-tipoIro="tipoIro">
  <span
    class="material-icons-outlined info-variabili-icon"
    style="padding-left: 10px"
    [appTooltipOverlay]="tooltipVariabiliTemplate"
    [variabiliTemplate]="{ iro: iro, tipoIro: tipoIro }"
    position="right"
  >
    help_outline
  </span>
</ng-template>

<!-- TEMPLATE TOOLTIP -->
<ng-template #tooltipVariabiliTemplate let-iro="iro" let-tipoIro="tipoIro">
  <app-tooltip-variabili-iro
    #cmpTooltipVatiableIro
    [iro]="iro"
    [tipoIro]="tipoIro"
  ></app-tooltip-variabili-iro>
</ng-template>
